export default __webpack_public_path__ + "images/ax-6651bb2513bc040f7f2b02f9c503b288.svg";